import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Paper } from '@material-ui/core'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import { theme, StyledH2 } from '../../../theme/Global'

export const SubProductLink = styled(Link)`
  color: ${theme.colors.blueText};
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  display: block;
  margin-left: 1rem;
  margin-bottom: 1.2rem;
  && {
    text-decoration: none;
  }
`
export const PaidLeaveSummaryLinkTile = styled(Paper)`
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  min-height: 100%;
  box-shadow: unset;
  margin-bottom: 2.5rem;
`

export const PaidLeaveSummaryLinkHeading = styled(StyledH2)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 24px;
  text-align: left;
  margin-bottom: 1rem;
`

export const PaidLeaveSummaryLinkIcon = styled(DescriptionOutlinedIcon)`
  &&& {
    font-size: 2.1rem;
    position: relative;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
`
